<div id="full-width" class="dialog widget widget-content corner-all front dialog-buttons draggable"
    style="height: auto; width:640px;display: block;top:283px;left:355px">
    <div class="dialog-titlebar widget-header corner-all" id="exampleModalLongTitle">
        <i class="fa fa-times fa-lg mng-qualifier-close-btn close2" (click)="activeModal.close('close')"
            title="close"></i>
    </div>
    <div style="width:auto;min-height :25px;padding: .5em 1em .5em .4em; ">
        <div>
            {{sheduleJobPopupMessage}}
        </div>
    </div>
    <div class="dialog-buttonpane" style="border-top: 1px solid #cecfd6;">
        <div>
            <button class=" btn btn-primary shadow-none" (click)="activeModal.close('close')">
                <span>{{'CLOSE'|translate}}</span>
            </button>
        </div>
    </div>
</div>
  


